export default __webpack_public_path__ + "static/media/vivawallet.da437b63.png";